import { UseQueryStateResult } from '@reduxjs/toolkit/dist/query/react/buildHooks.d'
import { createApi } from '@reduxjs/toolkit/query/react'

import baseQueryInterceptor from '@api/base-query-interceptor'
import { ApiResponse } from '@api/types/api-response.type'

import { roomQueryString } from '@utilities/helper'

export interface FloorPlateGalleryItemInterface {
  id: string
  type: 'image' | 'video'
  videoSrc?: string
  imageSrc?: string
  title?: string
  showcaseRoom?: string
}

export interface FloorPlateGalleryInterface {
  level: string
  block: string
  precinct: string
  stage: string
  assets: Array<FloorPlateGalleryItemInterface>
}

type FloorPlateGalleryTypeInterface = {
  projectName: string
}

export const floorPlateGalleryApi = createApi({
  reducerPath: 'floorPlateGalleryApi',
  baseQuery: baseQueryInterceptor,
  endpoints: (builder) => ({
    getFloorPlateGallery: builder.query<
      ApiResponse<Array<FloorPlateGalleryInterface>>,
      FloorPlateGalleryTypeInterface
    >({
      query: (params: FloorPlateGalleryTypeInterface) => ({
        url: `/v1/${params.projectName}/floor-plates${roomQueryString()}`,
        method: 'get',
      }),
    }),
  }),
})

export const selectFromResult = ({
  data,
  isLoading,
  isError,
  status,
}: UseQueryStateResult<any, any>): {
  floorPlateGalleryData: Array<FloorPlateGalleryInterface>
  isLoaded: boolean
  isError: boolean
  status: string
} => ({
  floorPlateGalleryData: data?.data || [],
  isLoaded: !isLoading,
  isError,
  status,
})

export const { useGetFloorPlateGalleryQuery } = floorPlateGalleryApi
